var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _line, _line2, _line3, _line4, _line5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar03({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 119,
    viewBox: "0 0 132 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H91V104H11.5997C5.49018 104 0.808766 98.5697 1.70876 92.5269L14 10Z",
    fill: "#861989"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9764_156157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6074 103.644L14.0016 10H109.002L125.343 102.61C126.207 107.509 122.439 112 117.465 112H39.4714C34.583 112 30.411 108.466 29.6074 103.644Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 13C33 16.2345 32.089 19.0759 30.7196 21.054C29.3447 23.0399 27.6435 24 26 24C24.3565 24 22.6553 23.0399 21.2804 21.054C19.911 19.0759 19 16.2345 19 13C19 9.76548 19.911 6.92413 21.2804 4.94603C22.6553 2.9601 24.3565 2 26 2C27.6435 2 29.3447 2.9601 30.7196 4.94603C32.089 6.92413 33 9.76548 33 13Z",
    stroke: "#B01BAE",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13C51 16.2345 50.089 19.0759 48.7196 21.054C47.3447 23.0399 45.6435 24 44 24C42.3565 24 40.6553 23.0399 39.2804 21.054C37.911 19.0759 37 16.2345 37 13C37 9.76548 37.911 6.92413 39.2804 4.94603C40.6553 2.9601 42.3565 2 44 2C45.6435 2 47.3447 2.9601 48.7196 4.94603C50.089 6.92413 51 9.76548 51 13Z",
    stroke: "#B01BAE",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68 13C68 16.2578 67.1329 19.1152 65.8365 21.0979C64.5285 23.0984 62.9521 24 61.5 24C60.0479 24 58.4715 23.0984 57.1635 21.0979C55.8671 19.1152 55 16.2578 55 13C55 9.74221 55.8671 6.88484 57.1635 4.90211C58.4715 2.90163 60.0479 2 61.5 2C62.9521 2 64.5285 2.90163 65.8365 4.90211C67.1329 6.88484 68 9.74221 68 13Z",
    stroke: "#B01BAE",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86 13C86 16.2345 85.089 19.0759 83.7196 21.054C82.3447 23.0399 80.6435 24 79 24C77.3565 24 75.6553 23.0399 74.2804 21.054C72.911 19.0759 72 16.2345 72 13C72 9.76548 72.911 6.92413 74.2804 4.94603C75.6553 2.9601 77.3565 2 79 2C80.6435 2 82.3447 2.9601 83.7196 4.94603C85.089 6.92413 86 9.76548 86 13Z",
    stroke: "#B01BAE",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104 13C104 16.2345 103.089 19.0759 101.72 21.054C100.345 23.0399 98.6435 24 97 24C95.3565 24 93.6553 23.0399 92.2804 21.054C90.911 19.0759 90 16.2345 90 13C90 9.76548 90.911 6.92413 92.2804 4.94603C93.6553 2.9601 95.3565 2 97 2C98.6435 2 100.345 2.9601 101.72 4.94603C103.089 6.92413 104 9.76548 104 13Z",
    stroke: "#B01BAE",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1562 35L14 10H109L113.418 35H18.1562Z",
    fill: "url(#paint0_linear_9764_156157)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41H43L45 52H33L31 41Z",
    fill: "#DFB8D5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56H46L48 67H36L34 56Z",
    fill: "#DFB8D5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70H49L51 81H39L37 70Z",
    fill: "#DFB8D5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M40 84H52L54 95H42L40 84Z",
    fill: "#DFB8D5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46 41H58L60 52H48L46 41Z",
    fill: "#DFB8D5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56H61L63 67H51L49 56Z",
    fill: "#DFB8D5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H64L66 81H54L52 70Z",
    fill: "#DFB8D5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84H67L69 95H57L55 84Z",
    fill: "#DFB8D5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41H73L75 52H63L61 41Z",
    fill: "#DFB8D5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64 56H76L78 67H66L64 56Z",
    fill: "#DFB8D5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67 70H79L81 81H69L67 70Z",
    fill: "#DFB8D5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70 84H82L84 95H72L70 84Z",
    fill: "#DFB8D5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41H88L90 52H78L76 41Z",
    fill: "#DFB8D5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56H91L93 67H81L79 56Z",
    fill: "#DFB8D5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M82 70H94L96 81H84L82 70Z",
    fill: "#DFB8D5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85 84H97L99 95H87L85 84Z",
    fill: "#DFB8D5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91 41H103L105 52H93L91 41Z",
    fill: "#B01BAE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M94 56H106L108 67H96L94 56Z",
    fill: "#DFB8D5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M97 70H109L111 81H99L97 70Z",
    fill: "#DFB8D5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100 84H112L114 95H102L100 84Z",
    fill: "#DFB8D5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 117.249,
    y1: 1,
    x2: 117.249,
    y2: 6,
    stroke: "black",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 111.177,
    y1: 2.82322,
    x2: 114.712,
    y2: 6.35876,
    stroke: "black",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 122.648,
    y1: 3.1735,
    x2: 119.178,
    y2: 6.77329,
    stroke: "black",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 122.358,
    y1: 14.7119,
    x2: 118.822,
    y2: 11.1764,
    stroke: "black",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 125.234,
    y1: 9.05078,
    x2: 120.234,
    y2: 9.05078,
    stroke: "black",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9764_156157",
    x: 8.00161,
    y: 5,
    width: 123.465,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_9764_156157"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.658312 0 0 0 0 0.658312 0 0 0 0 0.658312 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9764_156157"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9764_156157",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9764_156157",
    x1: 113.418,
    y1: 10,
    x2: 108.852,
    y2: 46.7771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B01BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA3F85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar03);
export default __webpack_public_path__ + "static/media/calendar-03.241d278e73d27ba8316cae6702847a08.svg";
export { ForwardRef as ReactComponent };